import { CreateDoctorReponseInfoEntity } from "@/domain/entity/admin/create-doctor-reponse-info-entity";
import { DoctorCreateResponseDto } from "@/data/dto/admin/doctor-create-reponse-dto";
import { assertDoctorCreateResponseDto } from "@/utils/validation";

export class CreateDoctorInfoMapper {
  static toEntity(dto: DoctorCreateResponseDto): CreateDoctorReponseInfoEntity {
    // AST 기반 타입 검증
    assertDoctorCreateResponseDto(dto);
    return {
      doctorUuid: dto.doctorUuid,
    };
  }
}
